/**
 * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
 */

function panelTemplate(state = global.__PRELOADED_STATE.panelTemplate) {
    return state;
}

/**
 * panelTemplate reducer
 */
export default panelTemplate;



// WEBPACK FOOTER //
// ./src/js/BookmakerRegPanel/panelTemplate.reducer.js